<a [routerLink]="rendering.fields.link.value.href" class="logo">
  <img *scImage="rendering.fields.image" />
</a>
